<div class="container-filtros">
  <small class="text-cinza text-filtros">Filtros</small>

  <div class="btn-group" uib-dropdown dropdown-append-to-body="true">
    <button type="button" class="btn" uib-dropdown-toggle>
       {{(calendar.filters.cultura.descricao || 'Cultura') | capitalize | characters:10}} <span class="caret"></span>
    </button>
    <ul class="dropdown-menu" uib-dropdown-menu role="menu">
      <li role="menuitem" ng-show="calendar.filters.cultura">
        <a ng-click="calendar.setValue('cultura', null)">Todas</a>
      </li>
      <li role="menuitem" ng-repeat="cultura in calendar.sharedData.culturas track by cultura.id">
        <a ng-click="calendar.setValue('cultura', cultura)">{{cultura.descricao | capitalize | characters:15}}</a>
      </li>
    </ul>
  </div>

  <div class="btn-group" uib-dropdown dropdown-append-to-body="true">
    <button type="button" class="btn" uib-dropdown-toggle>
       {{(calendar.filters.operacao.descricao || 'Operação') | capitalize  | characters:10}} <span class="caret"></span>
    </button>
    <ul class="dropdown-menu" uib-dropdown-menu role="menu">
      <li role="menuitem" ng-show="calendar.filters.operacao">
        <a ng-click="calendar.setValue('operacao', null)">Todas</a>
      </li>
      <li role="menuitem" ng-repeat="operacao in calendar.sharedData.operacoes track by operacao.id">
        <a ng-click="calendar.setValue('operacao', operacao)">{{operacao.descricao}}</a>
      </li>
    </ul>
  </div>

  <!-- TODO: completar comportamento das ocorrências -->
  <div class="btn-group" uib-dropdown dropdown-append-to-body="true" ng-show="calendar.isOperacaoOcorrencias() && calendar.filtroOcorrencias.length">
    <button type="button" class="btn" uib-dropdown-toggle>
       {{(calendar.filters.ocorrencia.descricao || 'Ocorrência') | capitalize  | characters:10}} <span class="caret"></span>
    </button>
    <ul class="dropdown-menu" uib-dropdown-menu role="menu">
      <li role="menuitem" ng-show="calendar.filters.ocorrencia">
        <a ng-click="calendar.setValue('ocorrencia', null)">Todas</a>
      </li>
      <li role="menuitem" ng-repeat="ocorrencia in calendar.filtroOcorrencias track by ocorrencia.id">
        <a ng-click="calendar.setValue('ocorrencia', ocorrencia)">{{ocorrencia.descricao | capitalize}}</a>
      </li>
    </ul>
  </div>

  <div class="btn-group" uib-dropdown dropdown-append-to-body="true">
    <button type="button" class="btn" uib-dropdown-toggle>
       {{(calendar.filters.gleba.descricao || 'Talhão') | capitalize | characters:10}} <span class="caret"></span>
    </button>
    <ul class="dropdown-menu" uib-dropdown-menu role="menu">
      <li role="menuitem" ng-show="calendar.filters.gleba">
        <a ng-click="calendar.setValue('gleba', null)">Todas</a>
      </li>
      <li role="menuitem" ng-repeat="gleba in calendar.glebas | orderBy: 'descricao' track by gleba.id">
        <a ng-click="calendar.setValue('gleba', gleba)">{{gleba.descricao | capitalize}}</a>
      </li>
    </ul>
  </div>

  <div class="btn-group" uib-dropdown dropdown-append-to-body="true">
    <button type="button" class="btn" uib-dropdown-toggle>
       {{(calendar.filters.usuario.descricao || 'Usuário') | capitalize | characters:10}} <span class="caret"></span>
    </button>
    <ul class="dropdown-menu" uib-dropdown-menu role="menu">
      <li role="menuitem" ng-show="calendar.filters.usuario">
        <a ng-click="calendar.setValue('usuario', null)">Todos</a>
      </li>
      <li role="menuitem" ng-repeat="usuario in calendar.sharedData.usuariosWithHistory track by usuario.id">
        <a ng-click="calendar.setValue('usuario', usuario)">{{usuario.descricao | capitalize}}</a>
      </li>
    </ul>
  </div>

  <br/>
  <div class="btn-group" uib-dropdown dropdown-append-to-body="true">
    <button type="button" class="btn" uib-dropdown-toggle>
       {{(calendar.filters.cultivar.descricao || 'Cultivar') | capitalize | characters:15}} <span class="caret"></span>
    </button>
    <ul class="dropdown-menu" uib-dropdown-menu role="menu">
      <li role="menuitem" ng-show="calendar.filters.cultivar">
        <a ng-click="calendar.setValue('cultivar', null)">Limpar Filtro</a>
      </li>
      <li role="menuitem">
        <a ng-click="calendar.setValue('cultivar', {descricao: 'Todas', item_id: 'todas'})">Todos</a>
      </li>
      <li role="menuitem" ng-repeat="cultivar in calendar.getCultivares() track by cultivar.item_id">
        <a ng-click="calendar.setValue('cultivar', cultivar)">{{cultivar.descricao | capitalize}}</a>
      </li>
    </ul>
  </div>

  <div class="btn-group dropdown" ng-show="calendar.selectedDate">
    <button type="button" class="btn" uib-tooltip="Limpar data" tooltip-append-to-body="true" tooltip-placement="right" ng-click="calendar.clearDate()">
      <i class="fa fa-ban"></i>
    </button>
  </div>
</div>

<div class="calendar" ng-class="{disabled: !calendar.selectedDate}">
  <uib-datepicker ng-model="calendar.selectedDate"
                  datepicker-options="calendar.datePickerOptions"
                  ng-change="calendar.setDate()"
                  ng-disabled="calendar.disabled"></uib-datepicker>
</div>
